import { render, staticRenderFns } from "./RpmBillModal.vue?vue&type=template&id=6b3b8450&scoped=true"
import script from "./RpmBillModal.vue?vue&type=script&lang=js"
export * from "./RpmBillModal.vue?vue&type=script&lang=js"
import style0 from "./RpmBillModal.vue?vue&type=style&index=0&id=6b3b8450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b8450",
  null
  
)

export default component.exports